module.exports = __webpack_public_path__ + "img/videosdk-item-2.9aef019.png";